__webpack_require__.p = "/wp-content/plugins/pitv2/assets/2d29a07c1e4707a8a62d790f630472a1f99e3dd4/bundles/";